import React from "react";

import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";

import { formatName, formatIsoDate } from "../../utils/generalUtils";

import UPLOGO from "../../generatePdf/components/up-logo.jpg";
import Ibm from "../../generatePdf/components/ibm.ttf";

import ArialRegular from "../../generatePdf/components/Arial/ARIAL.TTF";
import ArialBold from "../../generatePdf/components/Arial/ARIALBD.TTF";
import ArialItalic from "../../generatePdf/components/Arial/ARIALI.TTF";
import ArialNarrowItalic from "../../generatePdf/components/Arial/ARIALNI.TTF";
import ArialNarrowBold from "../../generatePdf/components/Arial/ARIALNB.TTF";
import ArialNarrowBoldItalic from "../../generatePdf/components/Arial/ARIALNBI.TTF";

Font.register({
  family: "ibm",
  format: "truetype",
  src: Ibm,
});

Font.register({
  family: "Arial",
  format: "truetype",
  src: ArialRegular,
});

Font.register({
  family: "ArialBold",
  format: "truetype",
  src: ArialBold,
});

Font.register({
  family: "ArialItalic",
  format: "truetype",
  src: ArialItalic,
});

Font.register({
  family: "ArialNarrowItalic",
  format: "truetype",
  src: ArialNarrowItalic,
});

Font.register({
  family: "ArialNarrowBold",
  format: "truetype",
  src: ArialNarrowBold,
});

Font.register({
  family: "ArialNarrowBoldItalic",
  format: "truetype",
  src: ArialNarrowBoldItalic,
});

const styles = StyleSheet.create({
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: "15px",
    fontFamily: "Arial",
    // fontWeight: "bold",
    gap: "5px",
  },
  headerupname: {
    display: "flex",
    flexDirection: "column",
  },
  subHeader: {
    paddingTop: "20px",
    fontFamily: "ibm",
    letterSpacing: "-1px",
    fontSize: "8px",
    alignItems: "left",
  },
  docuTypeName: {
    alignItems: "center",
    paddingTop: "20px",
    fontFamily: "ArialBold",
    // fontWeight: "bold",
    fontSize: "16px",
  },
  formContainer: {
    paddingTop: "30px",
    fontSize: "12px",
    gap: "6px",
  },
  formContainerCos: {
    paddingTop: "10px",
    fontSize: "10px",
    gap: "6px",
    fontFamily: "Arial",
  },
  fieldContainer: {
    fontSize: "11px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    letterSpacing: ".1px",
  },
  fieldName: {
    fontSize: "11px",
    letterSpacing: ".1px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontFamily: "Arial",
    width: "50%",
  },
  cosTable: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontFamily: "Arial",
    width: "50%",
    textAlign: "center",
    padding: "0px 10px",
    fontSize: "10px",
  },
  fieldItem: {
    letterSpacing: ".1px",
    paddingLeft: "10px",
    width: "50%",
    textTransform: "uppercase",
  },
  approvalContainer: {
    fontSize: "12px",
    gap: "12px",
  },
  approvalFields: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  approvalFieldName: {
    fontSize: "8px",
    fontFamily: "ArialItalic",
    border: "1px solid black",
    textAlign: "center",
  },
  endnoteContainer: {
    paddingTop: "20px",
  },
  image: {
    width: 50,
  },
});

function TrlFormat({ contents, isEmployee }) {
  const requesterName = contents.formattedName
    ? contents.formattedName
    : contents.name;
  const positionName = contents?.submitter_position;
  const approverName = isEmployee
    ? formatName(
        contents?.submission?.approval?.[0]?.approver?.first_name,
        contents?.submission?.approval?.[0]?.approver?.middle_name,
        contents?.submission?.approval?.[0]?.approver?.last_name,
        "lfmcut"
      )
    : contents?.formattedApproverName;

  const documentSubmitted = contents?.date_submitted;

  const startDate = contents?.start_date;
  const endDate = contents?.end_date;

  const rangeDate =
    startDate === endDate
      ? formatIsoDate(startDate, false)
      : `${formatIsoDate(startDate, false)} to ${formatIsoDate(
          endDate,
          false
        )}`;

  const destination = contents?.destination;
  const purpose = contents?.purpose;
  const estimatedExpense = contents?.expenses;
  const sourceFund = contents?.funding_sourse;
  const transportation = contents?.local_travel_transportation;
  const remarks = contents?.remarks;

  const approvalDate = contents?.approval_date;

  return (
    <View>
      <View>
        <View style={styles.header}>
          <Image src={UPLOGO} style={styles.image} />
          <View style={styles.headerupname}>
            <Text style={styles.text1}>University of the Philippines</Text>
            <Text style={styles.text1}>OPEN UNIVERSITY</Text>
            <Text
              style={{
                ...styles.text1,
                fontSize: "10px",
                fontWeight: "200",
              }}
            >
              Los Banos Laguna
            </Text>
          </View>
        </View>
        <View
          style={{
            ...styles.subHeader,
          }}
        >
          <Text>UP-HR Form No. 0006</Text>
          <Text>Revised 19 Oct 2016</Text>
          {/* <Text>TO No. 000295636</Text> */}
        </View>
        <View style={styles.docuTypeName}>
          <Text>TRAVEL REQUEST</Text>
        </View>
        <View style={styles.formContainer}>
          <View style={styles.fieldContainer}>
            <View style={styles.fieldName}>
              <Text>Date & Time Submitted</Text>
              <Text>: </Text>
            </View>
            <View style={styles.fieldItem}>
              <Text>{documentSubmitted}</Text>
            </View>
          </View>
          <View style={styles.fieldContainer}>
            <View style={styles.fieldName}>
              <Text>Name</Text>
              <Text>: </Text>
            </View>
            <View style={styles.fieldItem}>
              <Text>{requesterName}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.fieldName}>
              <Text>Designation</Text>
              <Text>: </Text>
            </View>
            <View style={styles.fieldItem}>
              <Text>{positionName}</Text>
            </View>
          </View>

          <View
            style={{
              ...styles.fieldContainer,
              paddingTop: "40px",
            }}
          >
            <View style={styles.fieldName}>
              <Text>Date of Travel</Text>
              <Text>: </Text>
            </View>
            <View
              style={{
                ...styles.fieldItem,
                textTransform: "lowercase",
              }}
            >
              <Text>{rangeDate}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.fieldName}>
              <Text>Destination</Text>
              <Text>: </Text>
            </View>
            <View
              style={{
                ...styles.fieldItem,
                textTransform: "none",
              }}
            >
              <Text>{destination}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.fieldName}>
              <Text>Purpose</Text>
              <Text>: </Text>
            </View>
            <View
              style={{
                ...styles.fieldItem,
                textTransform: "none",
              }}
            >
              <Text>{purpose}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.fieldName}>
              <Text>Estimated Expenses</Text>
              <Text>: </Text>
            </View>
            <View style={styles.fieldItem}>
              <Text>{estimatedExpense}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.fieldName}>
              <Text>Source of Fund</Text>
              <Text>: </Text>
            </View>
            <View style={styles.fieldItem}>
              <Text>{sourceFund}</Text>
            </View>
          </View>

          <View style={styles.fieldContainer}>
            <View style={styles.fieldName}>
              <Text>Transportation</Text>
              <Text>: </Text>
            </View>
            <View style={styles.fieldItem}>
              <Text>{transportation}</Text>
            </View>
          </View>

          <View
            style={{
              ...styles.fieldContainer,
              paddingBottom: "40px",
            }}
          >
            <View style={styles.fieldName}>
              <Text>Remarks</Text>
              <Text>: </Text>
            </View>
            <View
              style={{
                ...styles.fieldItem,
                textTransform: "none",
              }}
            >
              <Text>{remarks}</Text>
            </View>
          </View>
        </View>
        <View style={{ ...styles.approvalContainer, fontSize: "10px" }}>
          <Text>Approval History</Text>
          <View style={styles.approvalFields}>
            <Text
              style={{
                ...styles.approvalFieldName,
                width: "40%",
              }}
            >
              Name
            </Text>
            <Text
              style={{
                ...styles.approvalFieldName,
                width: "30%",
                borderLeft: "none",
                borderRight: "none",
              }}
            >
              Action
            </Text>
            <Text
              style={{
                ...styles.approvalFieldName,
                width: "30%",
              }}
            >
              Date/Time
            </Text>
          </View>
        </View>

        <View style={styles.approvalContainer}>
          <View style={styles.approvalFields}>
            <Text
              style={{
                ...styles.approvalFieldName,
                borderTop: "none",
                textTransform: "uppercase",
                width: "40%",
              }}
            >
              {approverName}
            </Text>
            <Text
              style={{
                ...styles.approvalFieldName,
                borderTop: "none",
                borderLeft: "none",
                borderRight: "none",
                textTransform: "uppercase",
                width: "30%",
              }}
            >
              approved
            </Text>
            <Text
              style={{
                ...styles.approvalFieldName,
                borderTop: "none",
                textTransform: "uppercase",
                width: "30%",
              }}
            >
              {approvalDate}
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.endnoteContainer}>
        <View style={{ fontFamily: "ArialItalic", fontSize: "8px" }}>
          <Text>This is a UPOU-PIVOT generated report.</Text>
          <Text>Approver's signature not required</Text>
        </View>
        <View style={{ fontSize: "10px", paddingTop: "15px", fontSize: "8px" }}>
          <Text>Reference:</Text>
          <Text style={{ paddingLeft: "30px", fontSize: "8px" }}>
            Administrative Order No. PAEP 16-28, 25 May 2016 "Use of Official UP
            Mail and Online Release of Service Records, Travel Order, Employment
            Certification and other Certificates."{" "}
          </Text>
        </View>
      </View>
    </View>
  );
}

export default TrlFormat;
